import DeviationColumnTemplate from "../reports/templates/columnTemplates/DeviationColumnTemplate.js";
import Model from "../Model.js";

/**
 * Abstract class modeling a type of deviation, i.e. how a deviation is
 * represented. A deviation is the difference between two values, e.g. between
 * two columns of a Report.
 * This class is able to generate {@link DeviationColumnTemplate}s that respect
 * the type of deviation.
 * For example, we have two columns with the values 100 and 200. The deviation is:
 * 100 for an absolute value and 100% for a percentage.
 *
 * @abstract
 */
export default class AbstractDeviationType extends Model {
	getLabel() {
		this._subclassResponsibility();
	}

	getType() {
		return this.constructor.getType();
	}

	equals(candidate) {
		if (!candidate) {
			return false;
		}

		return this.getType() === candidate.getType();
	}

	makeDeviationColumnTemplate({
		baseValuesColumnTemplateId: _baseValuesColumnTemplateId,
		deviatedValuesColumnTemplateId: _deviatedValuesColumnTemplateId,
		reportTemplate: _reportTemplate,
	}) {
		this._subclassResponsibility();
	}

	_makeDeviationColumnTemplate({
		baseValuesColumnTemplateId,
		deviatedValuesColumnTemplateId,
		reportTemplate,
		inPercent = false,
	}) {
		return new DeviationColumnTemplate({
			hidden: false,
			optional: false,
			reportTemplate,
			visibleWhenNoData: true,
			baseValuesColumnTemplateId,
			deviatedValuesColumnTemplateId,
			inPercent,
			showDeviationInfoInTitle: true,
		});
	}
}
